import React, { useState } from 'react';
import { ListActionButton } from './ListActionButton';
import { ActionIconName } from '../Icons';
import { ConfirmationAsidePanel } from '../AsidePanel/ConfirmationAsidePanel';
import { getTheme } from '@uifabric/styling';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function ListActionDelete(props) {
  const [isPanelVisible, setIsPanelVisible] = useState(false);
  const onConfirmClick = () => {
    setIsPanelVisible(false);
    props.onConfirm(props.item, props.index);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ConfirmationAsidePanel, {
      isOpen: isPanelVisible,
      onConfirmClick: onConfirmClick,
      onCancelClick: () => setIsPanelVisible(false),
      subText: props.subText
    }), /*#__PURE__*/_jsx(ListActionButton, {
      onClick: () => props.isConfirmationNeeded ? setIsPanelVisible(true) : onConfirmClick(),
      iconName: ActionIconName.Delete,
      iconColor: !props.disabled && getTheme().palette.red || '',
      index: props.index,
      disabled: props.disabled,
      id: props.id,
      dataId: props.dataId
    })]
  });
}
ListActionDelete.defaultProps = {
  subText: 'Are you sure you want to delete this item?',
  isConfirmationNeeded: true
};